import type {I18nKey} from "@zaaaz/shared";

export type HomepageHeroSlide = {
  image: string;
  url: string;
  eyebrowKey: I18nKey;
  titleKey: I18nKey;
  subtitleKey: I18nKey;
  ctaKey: I18nKey;
};

export const HOMEPAGE_HERO_SLIDES: HomepageHeroSlide[] = [
  {
    image: "/images/hero/promo-offers.jpg",
    url: "/promotions",
    eyebrowKey: "Carousel hero promo eyebrow",
    titleKey: "Carousel hero promo title",
    subtitleKey: "Carousel hero promo subtitle",
    ctaKey: "Carousel hero promo cta"
  },
  {
    image: "/images/hero/fast-delivery.jpg",
    url: "/transport-gratis",
    eyebrowKey: "Carousel hero delivery eyebrow",
    titleKey: "Carousel hero delivery title",
    subtitleKey: "Carousel hero delivery subtitle",
    ctaKey: "Carousel hero delivery cta"
  },
  {
    image: "/images/hero/authentic-brands.jpg",
    url: "/branduri",
    eyebrowKey: "Carousel hero brands eyebrow",
    titleKey: "Carousel hero brands title",
    subtitleKey: "Carousel hero brands subtitle",
    ctaKey: "Carousel hero brands cta"
  }
];
